<template>

    <div class="c-form_input">
        <form-label v-if="label">{{ label }}</form-label>
        <div
            class="c-form_input__inner"
            :class="{ 'c-form_input__inner--with-btn' : btn}">
            <div class="c-form_input__inner-input" :class="innerClass">
                <input
                    v-bind="$attrs"
                    v-if="['text', 'number', 'email', 'password'].indexOf(type) !== -1"
                    ref="input"
                    :type="type"
                    :value="value"
                    :name="inputName"
                    class="c-form_input__input c-form_input__input--input"
                    :class="{
            'c-form_input__input--error' : getError || error,
            'c-form_input__input--number' : (type === 'number'),
            'c-form_input__input--input-stt' : speechToText
          }"
                    :disabled="disabled"
                    @input="updateValue"
                    @keydown.enter="btnClick"
                    @change="updateValue"
                    @focus="$emit('focus')"
                    @blur="$emit('blur')"
                    autocomplete="off"
                    :list="(listOptions && listOptions.length) ? (inputName + 'List') : null">

                <datalist v-if="listOptions && listOptions.length" :id="inputName + 'List'">
                    <option v-for="listOption in listOptions">{{ listOption }}</option>
                </datalist>

                <textarea
                    v-bind="$attrs"
                    v-else-if="type === 'textarea'"
                    ref="input"
                    :value="value"
                    :name="inputName"
                    class="c-form_input__input c-form_input__input--textarea"
                    :class=" {
            'c-form_input__input--error' : getError || error,
            'c-form_input__input--textarea-stt' : speechToText
          }"
                    :disabled="disabled || btnLoading"
                    @input="updateValue"
                    @change="updateValue"
                    @blur="$emit('blur')">
        </textarea>
                <v-speech-to-text
                    v-if="speechToText"
                    :value="value"
                    @speaking="updateValueFromSpeaking"
                    class="c-form_input__stt">
                </v-speech-to-text>
            </div>

            <v-btn
                v-if="btn"
                :type="btn"
                class="c-form_input__btn"
                :class="{ 'c-form_input__btn--hidden' : !btnVisible }"
                @click="btnClick"
                :disabled="disabled"
                :hasLoader="btnHasLoader"
                :loading="btnLoading">
                {{ btnLabel }}
            </v-btn>
        </div>
        <form-error-msg :msg="error || getError"></form-error-msg>
    </div>

</template>


<script>

import FormErrorMsg from './FormErrorMsg'
import FormLabel from './FormLabel'
import VBtn from 'Components/VBtn'
import VSpeechToText from 'Components/VSpeechToText'
import caretAtEnd from 'Utils/CaretAtEnd'

export default {

    name: 'FormInput',

    inheritAttrs: false,

    $_veeValidate: {
        name() {
            return this.inputName
        },
        value() {
            return this.value;
        },
    },

    props: {
        value: [String, Number],
        label: String,
        name: String,
        btn: String,
        btnLabel: String,
        btnHasLoader: Boolean,
        btnLoading: Boolean,
        btnVisible: {
            type: Boolean,
            default: true
        },
        type: {
            type: String,
            default: "text"
        },
        disabled: Boolean,
        innerClass: [String, Object],
        speechToText: Boolean,
        error: String,
        listOptions: Array
    },

    computed: {
        inputName() {
            var tmp_name = this.$vnode.data.model.expression.split('.')
            var name = ''

            if (tmp_name.length > 1)
                name = tmp_name[tmp_name.length - 1]
            else
                name = tmp_name[0]

            return this.name || name
        },
        getError() {
            var err = this.errors.items.filter((error) => {
                return (error.field === this.inputName)
            })

            if (err.length)
                return err[0].msg
            else
                return null
        }
    },

    methods: {
        updateValue(e) {
            if (this.type === 'number') {
                e.target.value = parseInt(e.target.value) || 0
                this.$emit("input", parseInt(e.target.value), e)
            } else {
                this.$emit("input", e.target.value, e)
            }
        },
        updateValueFromSpeaking(value) {
            this.$emit("input", value)
            caretAtEnd(this.$refs.input)
        },
        btnClick(e) {
            if (this.btn)
                e.preventDefault()
            this.$emit('click', this.value)
        }
    },

    components: {
        FormErrorMsg,
        FormLabel,
        VBtn,
        VSpeechToText
    },

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-form_input {
    width: 100%;
    margin-bottom: 1rem;

    &__input {
        display: block;
        width: 100%;
        border-radius: 5px;
        border: 1px solid $c-border;
        font-size: 1rem;
        line-height: 2.4rem;
        height: 2.4rem;
        padding: 0 0.8rem;
        color: $c-third;

        &--textarea {
            resize: none;
            line-height: 1.5;
            height: 12rem;
            padding: 0.8rem;

            &-stt {
                padding-bottom: calc(2.4rem - 2px);
            }
        }
        &--input-stt {
            padding-right: 87px;

            @include bp($screen-sm) {
                padding-right: 61px;
            }
        }
        &--number {
            padding-right: 0;
        }
        &--error {
            border-color: $c-red;
        }
    }
    &__inner {
        display: flex;

        &-input {
            display: block;
            position: relative;
            width: 100%;
        }
    }
    &__btn {
        margin-left: .7rem;
        opacity: 1;
        transition: opacity .2s ease-in-out;

        &--hidden {
            pointer-events: none;
            opacity: 0;
        }
    }
    &__stt {
        position: absolute;
        bottom: 1px;
        right: 1px;
    }
}

</style>

